import { useQuery } from "@tanstack/react-query"
import { websiteAttributeService } from "../services/websiteAttributeService"

export const useWebsiteAttribute = () => {
  return useQuery({
    queryKey: ["attributes"],
    queryFn: ({ signal }) => websiteAttributeService.getAttributes(signal),
  })
}
